export default "__VITE_ASSET__b7s$gVLJ__"